// context/ConsultaContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface ConsultaContextType {
  consulta: Consultas | null;
  setConsulta: (plano: Consultas | null) => void;
}

const ConsultaContext = createContext<ConsultaContextType | undefined>(undefined);

export const ConsultaProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [consulta, setConsulta] = useState<Consultas | null>(null);

  return (
    <ConsultaContext.Provider value={{ consulta, setConsulta }}>
      {children}
    </ConsultaContext.Provider>
  );
};

export const useConsulta = (): ConsultaContextType => {
  const context = useContext(ConsultaContext);
  if (!context) throw new Error('useConsulta deve estar dentro do ConsultaProvider');
  return context;
};
